import { useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Route-level pending UI appears only on slow client-side navigation.
 * The initial HTML splash owns the first load until the route is rendered.
 * Portal to <body> so translated/layout ancestors cannot pin it at the top.
 */
export function SliderBrandLoader() {
  const [motionReady, setMotionReady] = useState(false);
  const persian =
    typeof document !== 'undefined' && document.documentElement.lang === 'fa';

  return createPortal(
    <div
      className={motionReady ? 'slider-brand-loader is-motion-ready' : 'slider-brand-loader'}
      role="status"
      aria-live="polite"
      aria-label={persian ? 'در حال بارگذاری اسلایدر' : 'Loading Slider'}
    >
      <div className="slider-brand-loader-art" aria-hidden="true">
        <img
          className="slider-brand-loader-fallback"
          src="/brand/slider-monogram.svg?v=boot-20261105c"
          alt=""
          width={292}
          height={262}
        />
        <img
          className="slider-brand-loader-motion"
          src="/brand/slider-loader-animated.svg?v=boot-20261105c"
          alt=""
          width={1250}
          height={650}
          decoding="async"
          onLoad={(event) => {
            if (event.currentTarget.naturalWidth > 0) setMotionReady(true);
          }}
        />
      </div>
    </div>,
    document.body,
  );
}
